module.exports = __webpack_public_path__ + "img/appstore.b45d6e78.png";